import React, { useContext, useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { AuthContext } from '../../AuthContext';
import { FaPenFancy } from 'react-icons/fa';

export default function TermsTextEditor() {
  const [value, setValue] = useState('');
  const [termId, setTermId] = useState(null); // track if editing or adding
  const { authState } = useContext(AuthContext); // contains token

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await axios.get('/api/terms/terms-conditions');

        console.log(res.data);
        if (res.data) {
          setValue(res.data.terms);
          setTermId(res.data._id);
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Error fetching terms:', error);
        }
      }
    };
    fetchTerms();
  }, [authState?.token]);

  const handleSave = async () => {
    try {
      if (termId) {
        const res = await axios.put(
          `/api/terms/edit/terms-condition/${termId}`,
          { terms: value },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authState?.token}`,
            },
          }
        );
        alert('✅ Terms and Conditions updated successfully!');
        console.log('Updated Terms and Conditions:', res.data);
      } else {
        const res = await axios.post(
          '/api/terms/add/terms-condition',
          { terms: value },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authState?.token}`,
            },
          }
        );
        alert('✅ Terms and Conditions created successfully!');
        setTermId(res.data.terms._id);
      }
    } catch (error) {
      console.error('Error saving terms:', error);
      alert(`❌ Failed: ${error.response?.data?.message || 'Something went wrong.'}`);
    }
  };

  return (
    <div
      className="fade-in"
      style={{
        width: '100%',
        margin: '40px auto',
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
      }}
    >
      <div>
        <h4
          style={{
            marginBottom: '20px',
            textAlign: 'center',
            color: '#333',
            fontWeight: '600',
          }}
        >
          <FaPenFancy /> {termId ? 'Edit Terms and Conditions' : 'Add Terms and Conditions'}
        </h4>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={setValue}
          style={{
            height: '50vh',
            marginBottom: '40px',
            backgroundColor: '#fafafa',
            borderRadius: '10px',
          }}
        />
      </div>

      <div style={{ textAlign: 'center' }}>
        <button className="btn btn-enhanced btn-primary-enhanced px-5" onClick={handleSave}>
          {termId ? 'Update Settings' : 'Save Settings'}
        </button>
      </div>
    </div>
  );
}
